import React from "react";
import styles from "./logo-marquee.module.css";

// Marquee logos - using assets found in public/assets/logos/
const FEATURED_LOGOS = [
  { name: "Women's Health", src: "/assets/logos/wh-logo.webp" },
  { name: "Oprah", src: "/assets/logos/oprah-logo.webp" },
  { name: "Prevention", src: "/assets/logos/prevention-logo.webp" },
  { name: "Good Housekeeping", src: "/assets/logos/good-housekeeping-logo.webp" },
  { name: "Women's Day", src: "/assets/logos/womens_day_logo.webp" },
  { name: "Health", src: "/assets/logos/health-logo.webp" },
  { name: "NPR", src: "/assets/logos/npr-logo.svg" },
  { name: "Men's Health", src: "/assets/logos/mh-logo.webp" },
  { name: "Forbes", src: "/assets/logos/forbes-logo.png" },
  { name: "Yoga Journal", src: "/assets/logos/yj-logo.webp" },
  { name: "Maria Shriver's Sunday Paper", src: "/assets/logos/maria-shriver-logo.svg" },
  { name: "Johnson & Johnson", src: "/assets/logos/jandj-logo.webp" },
];


interface LogoItem {
  name: string;
  src: string;
}

interface LogoMarqueeProps {
  logos?: LogoItem[];
  title?: string;
  variant?: 'default' | 'stacked';
  logoHeight?: number | string;
  spacing?: "default" | "compact";
  backgroundColor?: string;
}

export default function LogoMarquee({
  logos = FEATURED_LOGOS,
  title = "You've seen Meghan's work in",
  variant = 'default',
  logoHeight = 24,
  spacing = "default",
  backgroundColor = "white"
}: LogoMarqueeProps) {
  return (
    <div className={spacing === "compact" ? styles.marqueeBarCompact : styles.marqueeBar} style={{ backgroundColor }}>
      <div className={`${styles.marqueeWrapper} ${variant === 'stacked' ? styles.stacked : ''}`}>
        {/* <span className={styles.marqueeLabel}>
          {title}
        </span> */}

        {/* 
            Container for the scrolling track. 
            We duplicate the logo set twice.
            The CSS animation translates -50%, which corresponds to exactly one full set of logos plus gaps.
            Because 'gap' is on the container, we don't need manual margins on images, 
            but we need to make sure the gap applies between the two sets too.
        */}
        <div className={styles.marqueeMask}>
          <div className={styles.marqueeTrack}>
            {/* Set 1 */}
            {logos.map((logo, index) => (
              <img
                key={`set1-${index}`}
                src={logo.src}
                alt={logo.name}
                className={styles.marqueeLogo}
                style={{ height: typeof logoHeight === 'number' ? `${logoHeight}px` : logoHeight }}
              />
            ))}
            {/* Set 2 */}
            {logos.map((logo, index) => (
              <img
                key={`set2-${index}`}
                src={logo.src}
                alt={logo.name}
                className={styles.marqueeLogo}
                style={{ height: typeof logoHeight === 'number' ? `${logoHeight}px` : logoHeight }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
